import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function InspectorsIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 26 24" fill="none">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.9941 9.937C24.9951 16.5253 19.8837 22.152 12.9004 23.25C5.91705 22.152 0.805686 16.5253 0.806641 9.937V2.25C0.806641 1.42157 1.52858 0.75 2.41914 0.75H23.3816C24.2722 0.75 24.9941 1.42157 24.9941 2.25V9.937Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8996 12C14.9034 12 16.5277 10.489 16.5277 8.625C16.5277 6.76104 14.9034 5.25 12.8996 5.25C10.8959 5.25 9.27148 6.76104 9.27148 8.625C9.27148 10.489 10.8959 12 12.8996 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.6914 16.7497C17.5896 14.7152 15.3494 13.4316 12.9004 13.4316C10.4514 13.4316 8.21124 14.7152 7.10938 16.7497"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
